exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BPACheckbox {\n  margin: 10px 0;\n  display: flex;\n  flex-direction: row;\n}\n.BPACheckbox .box {\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  border: 2px solid black;\n  margin-right: 8px;\n}", ""]);

